<template>
  <div class="individual-response">
    <span v-if="sessionString" class="sessionString">{{ sessionString }}</span>
    <span v-html="responseString" />
  </div>
</template>

<script>
import A from '@/utilities/alpha'

export default {
  props: ['response', 'keywords'],
  data: function () {
    return {
      hasSession: this.response.search(/^Session{1}\s+[0-9]{4}/g) !== -1
    }
  },
  computed: {
    sessionString: function () {
      if (this.hasSession) {
        return this.response.slice(0, 13)
      } else {
        return false
      }
    },
    responseString: function () {
      if (this.hasSession) {
        return this.highlightedResponse(A.stripHTML(this.response.slice(13)))
      } else {
        return this.highlightedResponse(A.stripHTML(this.response))
      }
    }
  },
  methods: {
    highlightedResponse: function (response) {
      if (this.keywords && this.keywords.length > 0) {
        var regexMatch = new RegExp(this.keywords.map(function (w) { return '\\b' + w + '\\b' }).join('|'), 'gi')
        response = response.replace(regexMatch, function (matched) {
          return '<span style="font-weight: bold;">' + matched + '</span>'
        })
      }
      return response
    }
  }
}
</script>

<style scoped>
  .sessionString {
    margin-right: 10px;
    flex-shrink: 0;
    font-weight: 700;
    width: 95px;
  }

  .individual-response {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
</style>
